import React, { Component } from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

class Slider extends Component {
  render() {
    return <InputRange {...this.props} />;
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Form/Slider/index.js